import React, { Component } from 'react'
import LabelWrapper from '../labelWrapper'

import './textarea.scss'

class Textarea extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }
    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
  }

  onChange (e) {
    // console.log('Text onChange triggered! ', e)
    if (this.props.onChange !== null) {
      this.props.onChange(e)
    }
  }

  onBlur (e) {
    // console.log('Text onBlur triggered! ', e)
    if (this.props.onBlur !== null) {
      this.props.onBlur(e)
    }
  }

  getSizeClass () {
    switch (this.props.size) {
      case undefined:
      case null:
      case 'l':
        return 'size-large'
      case 'm':
        return 'size-medium'
      case 's':
        return 'size-small'
    }
  }

  getSolidClass () {
    return ''
  }

  getBorderClass () {
    return ''
  }

  getStyle () {
    return 'element-textarea' + this.getSolidClass() + this.getBorderClass()
  }

  render () {
    const renderInput = () => {
      return (
        <textarea
          className={this.getSizeClass()}
          name={this.props.name}
          value={this.props.value}
          onChange={this.onChange}
          onBlur={this.onBlur}
          placeholder={this.props.placeholder}
          disabled={this.props.disabled}
        />
      )
    }

    const renderWrapper = (content) => {
      return (
        <LabelWrapper
          labelText={this.props.labelText}
          hintText={this.props.hintText}
          helpText={this.props.helpText}
          errorText={this.props.errorText}
        >
          {content}
        </LabelWrapper>
      )
    }

    return (
      <div className={this.getStyle()}>
        {(!this.props.simple && this.props.labelText !== null) ? renderWrapper(renderInput()) : renderInput()}
      </div>
    )
  }
}

Textarea.defaultProps = {
  size: 'l',
  labelText: null,
  hintText: null,
  helpText: null,
  onChange: null,
  onBlur: null,
  placeholder: '',
  errorText: null,
  disabled: false,
  simple: false
}

export default Textarea



// WEBPACK FOOTER //
// ./src/app/shared/elements/textarea/index.js